module.exports = __webpack_public_path__ + "assets/images/Whiteshade.ce316e4e0a93f3ea907a05b9b5114ed1.png";